import { HttpErrorResponse } from '@angular/common/http';

export function isJsonParseHttpError(e: unknown): e is HttpErrorResponse {
  return e instanceof HttpErrorResponse
    && e.status === 200
    && /failure during parsing/i.test(e.message);
}
